import { Star } from "lucide-react";

export function StarRating({ value = 0, size = 4, interactive = false, onChange }) {
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className="inline-flex items-center gap-0.5">
      {stars.map((n) => {
        const filled = n <= Math.round(value);
        return (
          <button
            key={n}
            type="button"
            disabled={!interactive}
            onClick={() => interactive && onChange?.(n)}
            className={interactive ? "cursor-pointer" : "cursor-default"}
            data-testid={interactive ? `star-${n}` : undefined}
          >
            <Star
              className={`h-${size} w-${size} ${filled ? "fill-matpro-green stroke-matpro-green" : "stroke-zinc-300"}`}
              strokeWidth={1.5}
            />
          </button>
        );
      })}
    </div>
  );
}
